var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"p-1",attrs:{"align-v":"end"}},[_c('b-col',{attrs:{"cols":"4"}},[_c('img',{staticClass:"logo-margin",attrs:{"src":require("@/assets/logo-small.jpg"),"alt":"Ambit Logo","aria-label":"Ambit Logo"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }